module.exports = __webpack_public_path__ + "assets/img/23_432.04795c62.jpg";